export const SECOND_IN_MS = 1000;
export const MINUTE_IN_SECONDS = 60;
export const HOUR_IN_MINUTES = 60;
export const DAY_IN_HOURS = 24;
export const YEAR_IN_DAYS = 365.25;

export const HOUR_IN_SECONDS = MINUTE_IN_SECONDS * HOUR_IN_MINUTES;
export const DAY_IN_SECONDS = HOUR_IN_SECONDS * DAY_IN_HOURS;
export const YEAR_IN_SECONDS = DAY_IN_SECONDS * YEAR_IN_DAYS;
